var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"favorite d-inline-block",class:{'active':!!_vm.userHostFavorite},attrs:{"title":_vm.iconTitle},on:{"click":_vm.toggleFavHost}},[_c('font-awesome-icon',{attrs:{"icon":"heart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }